import React from 'react';
import { QuestionProps } from './types';
import { BaseInputQuestionInput } from './base-input-question-input';

export function TextfieldQuestionInput(
  props: QuestionProps,
): React.ReactElement {
  return <BaseInputQuestionInput {...props} type="text" />;
}
